export enum FilterViewEnum {
  HIDDEN = 'hidden',
  ALL = 'view all',
  NO_STATUS = 'no status',
  WATCH = 'watch',
  STAR = 'star',
}
